module.exports = __webpack_public_path__ + "media/images/social_preview_default-9f27aeb9d882e146ff2c2945b7686cff.jpg";